import { FabricObject } from "./FabricObject";
export class FabricRect extends FabricObject {
    constructor(args) {
        super(args);
        const keys = Object.keys(args);
        keys.forEach((key) => this[key] = args[key]);
    }
    setCoords() {
        this.dirty = true;
    }
    draw(ctx, scale) {
        ctx.fillStyle = this.fill;
        ctx.lineWidth = this.strokeWidth;
        ctx.strokeStyle = this.stroke;
        const o = this.strokeWidth / 3;
        ctx.fillRect(this.left + o, this.top + o, this.width + o, this.height + o);
        ctx.strokeRect(this.left + o, this.top + o, this.width + o, this.height + o);
    }
}
//# sourceMappingURL=FabricRect.js.map